import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiQuery } from '../../../../common/model/api.query';
import { UserStatisticsOutput } from '../model/user-statistics.output';

@Injectable({ providedIn: 'root' })
export class FetchUserStatisticsApiQuery extends ApiQuery<
	UserStatisticsOutput,
	void
> {
	client = 'iam';
	document = gql`
		query FetchUserStatistics {
			fetchUserStatistics {
				doneTasks
				pendingTasks
				doneJobMeetings
				pendingJobMeetings
				doneContactMeetings
				pendingContactMeetings
			}
		}
	`;
	method = 'fetchUserStatistics';
}
